/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Tooltip,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { productDetailsWidgets } from "../../../common/data/ecommerce";
import classnames from "classnames";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import { Link, useLocation, useParams } from "react-router-dom";
import { Swiper } from "swiper/react";
import { SwiperSlide } from "swiper/react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductDetail } from "../../../live-slices/products/thunk";
import { createSelector } from "reselect";
import ImageViewer from "Components/Common/ImageViewer";
import axios from "axios";
interface SpecialPrice {
  amount: number;
  startDate: string;
  endDate: string;
}
interface PricingDetails {
  price: number;
  specialPrice?: SpecialPrice;
}
interface VariantValue {
  name: string;
  price: number;
  stock: number;
  isAvailable: boolean;
  productId: string;
  images?: { url: string }[];
}
const ProductReview = (props: any) => {
  const price = props.pricingDetails?.price;
  const specialPrice = props.pricingDetails?.specialPrice;
  const now = new Date();
  const isSpecialActive =
    specialPrice?.startDate &&
    specialPrice?.endDate &&
    new Date(specialPrice.startDate) <= now &&
    new Date(specialPrice.endDate) >= now;
  return (
    <React.Fragment>
      <li className="py-2">
        <div className="border border-dashed rounded p-3">
          <div className="d-flex align-items-start mb-3">
            <div className="hstack gap-3">
              <div className="badge rounded-pill bg-success mb-0">
                <i className="mdi mdi-star"></i> {props.review.rating}
              </div>
              <div className="vr"></div>
              <div className="flex-grow-1">
                <p className="text-muted mb-0">{props.review.comment}</p>
              </div>
            </div>
          </div>
          {props.review.subItems && (
            <React.Fragment>
              <div className="d-flex flex-grow-1 gap-2 mb-3">
                {props.review.subItems.map((subItem: any, key: any) => (
                  <React.Fragment key={key}>
                    <Link to="#" className="d-block">
                      <img
                        src={subItem.img}
                        alt=""
                        className="avatar-sm rounded object-fit-cover"
                      />
                    </Link>
                  </React.Fragment>
                ))}
              </div>
            </React.Fragment>
          )}

          <div className="d-flex align-items-end">
            <div className="flex-grow-1">
              <h5 className="fs-15 mb-0">{props.review.name}</h5>
            </div>

            <div className="flex-shrink-0">
              <p className="text-muted mb-0">{props.review.date}</p>
            </div>
          </div>
        </div>
      </li>
    </React.Fragment>
  );
};
const PricingWidgetList = (props: any) => {
  const { pricingDetails, productInfo, selectedVariant } = props;
  const getDisplayPrice = () => {
    let basePrice = Number(productInfo.price);
    let specialPrice = productInfo.specialPrice?.amount;
    if (selectedVariant?.price) {
      basePrice = Number(selectedVariant.price);
      specialPrice = selectedVariant.specialPrice?.amount || null;
    }
    const isSpecial =
      productInfo.specialPrice?.startDate &&
      productInfo.specialPrice?.endDate &&
      new Date(productInfo.specialPrice.startDate) <= new Date() &&
      new Date(productInfo.specialPrice.endDate) >= new Date();
    return { basePrice, specialPrice: isSpecial ? specialPrice : null };
  };
  const { basePrice, specialPrice } = getDisplayPrice();
  return (
    <React.Fragment>
      <Col lg={12} sm={6}>
        <div className="p-2 border border-dashed rounded" style={{width:'fit-content'}}>
          <div className="d-flex align-items-center">
            <div className="avatar-sm me-2">
              <div className="avatar-title rounded bg-transparent text-success fs-24">
                {pricingDetails.icon === "ri-money-dollar-circle-fill" ? (
                  <span>RS</span>
                ) : (
                  <i className={pricingDetails.icon}></i>
                )}
              </div>
            </div>
            <div className="flex-grow-1">
              <h5 className="text-muted mb-0">
                Price:
                {specialPrice ? (
                  <>
                    <span
                      style={{
                        textDecoration: "line-through",
                        marginRight: "10px",
                      }}
                    >
                      {basePrice.toLocaleString()}
                    </span>
                    <span className="text-success fw-bold">
                      {Number(specialPrice).toLocaleString()}
                    </span>
                  </>
                ) : (
                  <span>{basePrice.toLocaleString()}</span>
                )}
              </h5>
            </div>
          </div>
        </div>
      </Col>
    </React.Fragment>
  );
};
function EcommerceProductDetail(props: any) {
  const [selectedVariant, setSelectedVariant] = useState<{
    [key: string]: any;
  }>({});
  const [productInfo, setProductInfo] = useState<any>(null);
  const ratingCount = productInfo?.ratingCount || 0;
  const fullStars = Math.max(0, Math.floor(ratingCount));
  const halfStars = ratingCount % 1 >= 0.5 ? 1 : 0;
  const emptyStars = Math.max(0, 5 - (fullStars + halfStars));
  const [isViewerOpen, setViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [thumbsSwiper, setThumbsSwiper] = useState<any>("");
  const [productDetail, setproductDetail] = useState<any>({});
  const [productImages, setProductImages] = useState<any>([]);
  const [allProductImages, setAllProductImages] = useState<any>([]);
  const dispatch: any = useDispatch();
  const params = useParams();
  const location = useLocation();
  const product_id =
    location.state?.product_id ||
    params.id ||
    new URLSearchParams(location.search).get("product_id");
  const [tooltipState, setTooltipState] = useState<Record<string, boolean>>({});
  document.title = "Product Details | BuyPass";
  const [ttop, setttop] = useState<boolean>(false);
  const [ssize, setssize] = useState<boolean>(false);
  const [msize, setmsize] = useState<boolean>(false);
  const [lsize, setlsize] = useState<boolean>(false);
  const [xlsize, setxlsize] = useState<boolean>(false);
  const [customActiveTab, setcustomActiveTab] = useState<any>("1");
  const [mainSwiperRef, setMainSwiperRef] = useState<any>(null);

  const generateProductImages = () => {
    let imagesToShow: any[] = [];
    if (selectedVariant && Object.keys(selectedVariant).length > 0) {
      for (const key in selectedVariant) {
        const value = selectedVariant[key];
        if (value?.images?.length > 0) {
          imagesToShow = value.images;
          break;
        }
      }
    }
    if (imagesToShow.length === 0) {
      if (productInfo?.mainImages?.length > 0) {
        imagesToShow = [productInfo.mainImages[0]];
      }
    }
    setProductImages(imagesToShow);
  };

  const generateProductImagesTwo = () => {
    const imagesToShow: any[] = [];
    productInfo?.variants?.forEach((variant: any) => {
      variant?.values?.forEach((value: any) => {
        value?.images?.forEach((img: any) => {
          imagesToShow.push({
            image: img,
            variantType: variant.type,
            variantValue: value,
            type: "image",
          });
        });
      });
    });
    productInfo?.mainImages?.forEach((mainImg: any) => {
      imagesToShow.push({
        image: mainImg,
        type: "image",
      });
    });
    const productVideo = productInfo?.productVideo;
    if (productVideo?.url) {
      imagesToShow.push({
        image: productVideo,
        type: "video",
      });
    }
    setAllProductImages(imagesToShow);
  };

  const toggleCustom = (tab: any) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const toggleTooltip = (key: string) => {
    setTooltipState((prevState: Record<string, boolean>) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const openViewer = (imageUrl: string) => {
    setCurrentImage(imageUrl);
    setViewerOpen(true);
  };

  const closeViewer = () => {
    setViewerOpen(false);
  };

  const getProductDetailByProductId = async (
    pid = product_id,
    selectedTypeAndValue?: { type: string; value: any }
  ) => {
    const res: any = await axios.get(
      `/api/v1/products/detail?productId=${pid}`
    );
    if (res.isSuccess && res.data) {
      const data = res.data;
      setProductInfo(data);
      const defaultSelection: { [key: string]: any } = {};
      data.variants?.forEach((variant: any, index: number) => {
        let matchedValue;
        if (
          selectedTypeAndValue &&
          variant.type === selectedTypeAndValue.type
        ) {
          matchedValue = variant.values.find(
            (v: any) => v.name === selectedTypeAndValue.value.name
          );
        }
        if (!matchedValue && selectedTypeAndValue) {
          matchedValue = variant.values.find(
            (v: any) => v.productId === data.id
          );
        }
        // if (!selectedTypeAndValue) {
        //   if (index === 0 && variant.values?.length > 0) {
        //     matchedValue = variant.values[0];
        //   }
        //   if (
        //     data.variants.length === 2 &&
        //     index === 1 &&
        //     variant.values?.length > 0
        //   ) {
        //     matchedValue = variant.values[0];
        //   }
        // }

        if (!selectedTypeAndValue) {
          matchedValue = variant.values[0];
        }

        if (matchedValue) {
          defaultSelection[variant.type] = matchedValue;
        }
      });
      setSelectedVariant(defaultSelection);
    }
  };

  const handleVariantChange = (variantType: string, value: any) => {
    const currentProductId =
      selectedVariant[Object.keys(selectedVariant)[0]]?.productId;
    const matchedIndex = allProductImages.findIndex(
      (entry: any) =>
        entry.variantType === variantType &&
        entry.variantValue?.name === value.name
    );
    if (matchedIndex !== -1) {
      const mediaUrl =
        allProductImages[matchedIndex].type === "video"
          ? allProductImages[matchedIndex].image?.url
          : typeof allProductImages[matchedIndex].image === "string"
          ? allProductImages[matchedIndex].image
          : allProductImages[matchedIndex].image?.url;

      setCurrentImage(mediaUrl);
      if (mainSwiperRef) {
        mainSwiperRef.slideTo(matchedIndex);
      }
    }
    if (value.productId === currentProductId) {
      setSelectedVariant((prev: any) => {
        return {
          ...prev,
          [variantType]: value,
        };
      });
      getProductDetailByProductId(value.productId, {
        type: variantType,
        value: value,
      });
    } else {
      getProductDetailByProductId(value.productId, {
        type: variantType,
        value: value,
      });
    }
  };

  useEffect(() => {
    getProductDetailByProductId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product_id]);

  useEffect(() => {
    if (productInfo) {
      generateProductImages();
      generateProductImagesTwo();
      setproductDetail(productInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productInfo]);

  useEffect(() => {
    generateProductImages();
    generateProductImagesTwo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedVariant]);

  if (!productInfo) {
    return;
  }
  
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Product Details"
          pageTitle="Products"
          pageTitleRoute="/manage-products"
        />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row className="gx-lg-5">
                  <Col xl={4} md={8} className="mx-auto">
                    <div className="product-img-slider sticky-side-div">
                      <Swiper
                        modules={[Navigation, FreeMode]}
                        navigation={true}
                        onSwiper={setMainSwiperRef}
                        className="swiper product-thumbnail-slider p-2 rounded bg-light"
                        style={{ height: "300px" }}
                      >
                        <div
                          className="swiper-wrapper"
                          style={{ height: "100%" }}
                        >
                          {allProductImages.map((entry: any, index: number) => {
                            const mediaUrl =
                              entry.type === "video"
                                ? entry.image?.url
                                : typeof entry.image === "string"
                                ? entry.image
                                : entry.image?.url ||
                                  entry.image?.images?.[0]?.url;

                            return (
                              <SwiperSlide key={index}>
                                <figure style={{ height: "100%" }}>
                                  {entry.type === "video" ? (
                                    <video
                                      src={mediaUrl}
                                      controls={true}
                                      className="img-fluid d-block"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                      }}
                                    ></video>
                                  ) : (
                                    <img
                                      src={mediaUrl}
                                      alt={`Product image ${index + 1}`}
                                      onClick={() => openViewer(mediaUrl)}
                                      className="img-fluid d-block"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                      }}
                                    />
                                  )}
                                </figure>
                              </SwiperSlide>
                            );
                          })}
                        </div>
                      </Swiper>
                      <div className="product-nav-slider mt-2">
                        <Swiper
                          onSwiper={setThumbsSwiper}
                          modules={[FreeMode, Thumbs]}
                          slidesPerView={4}
                          spaceBetween={10}
                          watchSlidesProgress
                          freeMode
                          className="swiper product-nav-slider mt-2 overflow-hidden"
                          onSlideChange={(swiper) => {}}
                        >
                          {allProductImages.map((entry: any, index: number) => {
                            const mediaUrl =
                              entry.type === "video"
                                ? entry.image?.url
                                : typeof entry.image === "string"
                                ? entry.image
                                : entry.image?.url ||
                                  entry.image?.images?.[0]?.url;

                            return (
                              <SwiperSlide key={index}>
                                <div
                                  style={{
                                    border:
                                      currentImage === mediaUrl
                                        ? "1px solid blue"
                                        : "1px solid transparent",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setCurrentImage(mediaUrl);
                                    if (mainSwiperRef) {
                                      mainSwiperRef.slideTo(index);
                                    }
                                    if (
                                      entry.type === "image" &&
                                      entry.variantType &&
                                      entry.variantValue
                                    ) {
                                      handleVariantChange(
                                        entry.variantType,
                                        entry.variantValue
                                      );
                                    }
                                  }}
                                >
                                  {entry.type === "video" ? (
                                    <video
                                      src={mediaUrl}
                                      controls={false}
                                      className="img-fluid d-block"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                      preload="metadata"
                                    ></video>
                                  ) : (
                                    <img
                                      src={mediaUrl}
                                      alt={`Product image ${index + 1}`}
                                      className="img-fluid d-block"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  )}
                                </div>
                              </SwiperSlide>
                            );
                          })}
                        </Swiper>
                      </div>
                    </div>
                    <ImageViewer
                      isOpen={isViewerOpen}
                      imageUrl={currentImage}
                      toggle={closeViewer}
                    />
                  </Col>
                  <Col xl={8}>
                    <div className="mt-xl-0 mt-5">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <h4 style={{  textAlign: "left" }}>
                            {productInfo?.title || "No product title available"}
                          </h4>
                          <div className="hstack ">
                            <div className="text-muted me-3">
                              Seller :
                              <span className="text-body fw-medium">
                                {productInfo?.seller?.name || "-"}
                              </span>
                            </div>
                            <div className="text-muted me-3">
                              Commission :
                              <span className="text-body fw-medium">
                                {`${productInfo?.commision?.pct || 0}%`}
                              </span>
                            </div>
                            <div className="text-muted">
                              Published :
                              <span className="text-body fw-medium">
                                {productInfo?.createdOn
                                  ? new Date(
                                      productInfo?.createdOn
                                    ).toLocaleDateString("en-US", {
                                      year: "numeric",
                                      month: "long",
                                      day: "numeric",
                                    })
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="flex-shrink-0">
                          <div className="d-flex align-items-center">
                            <Tooltip
                              placement="top"
                              isOpen={ttop}
                              target="TooltipTop"
                              toggle={() => setttop(!ttop)}
                            >
                              Edit
                            </Tooltip>
                            <a
                              href={`/product/edit/${productInfo.mainProductId}`}
                              id="TooltipTop"
                              className="btn btn-light d-flex align-items-center gap-2 me-3"
                            >
                              Edit
                              <i className="ri-pencil-fill align-bottom"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <Row className="mt-4">
                        {productDetailsWidgets.map((pricingDetails, key) => (
                          <PricingWidgetList
                            pricingDetails={{
                              ...pricingDetails,
                              price: productInfo?.price,
                            }}
                            productInfo={productInfo}
                            key={key}
                            selectedVariant={selectedVariant}
                          />
                        ))}
                      </Row>
                      <Row>
                        {productInfo?.variants?.map(
                          (
                            variant: any,
                            variantIndex: React.Key | null | undefined
                          ) => (
                            <Col xl={6} key={variantIndex}>
                              <div className="mt-4">
                                <h5 className="fs-15">{variant.type}:</h5>
                                <div className="d-flex flex-wrap gap-2">
                                  {variant.values.map(
                                    (
                                      value: {
                                        isAvailable: boolean;
                                        name: string;
                                        stock: number;
                                      },
                                      valueIndex: React.Key | null | undefined
                                    ) => {
                                      const isSelected =
                                        selectedVariant[variant.type]?.name ===
                                        value.name;
                                      return (
                                        <React.Fragment key={valueIndex}>
                                          {variant.type === "" ? (
                                            <>
                                              <Input
                                                type="radio"
                                                className="btn-check"
                                                name={`product-${variant.type}`}
                                                id={`variant-${variantIndex}-${valueIndex}`}
                                                disabled={!value.isAvailable}
                                                onClick={() =>
                                                  setSelectedVariant(value)
                                                }
                                              />
                                              <Label
                                                htmlFor={`variant-${variantIndex}-${valueIndex}`}
                                                className={`btn btn-soft-primary avatar-xs rounded-circle p-4 d-flex justify-content-center align-items-center ${
                                                  !value.isAvailable
                                                    ? "disabled"
                                                    : ""
                                                }`}
                                                id={`Tooltip-${variantIndex}-${valueIndex}`}
                                              >
                                                {value.name}
                                              </Label>
                                              <Tooltip
                                                placement="top"
                                                isOpen={
                                                  tooltipState[
                                                    `Tooltip-${variantIndex}-${valueIndex}`
                                                  ]
                                                }
                                                target={`Tooltip-${variantIndex}-${valueIndex}`}
                                                toggle={() =>
                                                  toggleTooltip(
                                                    `Tooltip-${variantIndex}-${valueIndex}`
                                                  )
                                                }
                                              >
                                                {value.isAvailable
                                                  ? `${value.stock} Items Available`
                                                  : "Out of Stock"}
                                              </Tooltip>
                                            </>
                                          ) : (
                                            <div
                                              data-bs-toggle="tooltip"
                                              data-bs-placement="top"
                                              title={
                                                value.isAvailable
                                                  ? `${value.stock} Items Available`
                                                  : "Out of Stock"
                                              }
                                            >
                                              <button
                                                type="button"
                                                className={`btn p-2 d-flex align-items-center justify-content-center border rounded fs-14 ${
                                                  isSelected
                                                    ? "btn-primary text-white"
                                                    : value.isAvailable
                                                    ? "text-primary"
                                                    : "text-muted"
                                                }`}
                                                onClick={() =>
                                                  handleVariantChange(
                                                    variant.type,
                                                    value
                                                  )
                                                }
                                              >
                                                {value.name}
                                              </button>
                                            </div>
                                          )}
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </Col>
                          )
                        )}
                      </Row>
                      <div className="product-content mt-5">
                        <h5 className="fs-15 mb-3">
                          Product Description :
                          <span
                            dangerouslySetInnerHTML={{
                              __html: productInfo?.productDescription || "",
                            }}
                          />
                        </h5>
                        <div />
                        <Nav tabs className="nav-tabs-custom nav-success">
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: customActiveTab === "1",
                              })}
                              onClick={() => {
                                toggleCustom("1");
                              }}
                            >
                              Specification
                            </NavLink>
                          </NavItem>
                        </Nav>
                        <TabContent
                          activeTab={customActiveTab}
                          className="border border-top-0 p-4"
                          id="nav-tabContent"
                        >
                          <TabPane id="nav-speci" tabId="1">
                            <div className="table-responsive">
                              <table className="table mb-0">
                                <tbody>
                                  {productInfo?.subProducts &&
                                    productInfo.subProducts.length > 0 &&
                                    (selectedVariant &&
                                    Object.keys(selectedVariant).length > 0
                                      ? productInfo.subProducts.filter(
                                          (subProduct: any) =>
                                            Object.values(selectedVariant).some(
                                              (variant) =>
                                                variant.productId ===
                                                subProduct._id
                                            )
                                        )
                                      : productInfo.subProducts
                                    ).map(
                                      (
                                        subProduct: {
                                          name: string;
                                          sku: string;
                                        },
                                        index: number
                                      ) => (
                                        <tr key={index}>
                                            Sku: {productInfo.buypassId} - {subProduct.sku}
                                          {/* <td></td> */}
                                        </tr>
                                      )
                                    )}
                                </tbody>
                              </table>
                            </div>
                          </TabPane>
                          <TabPane id="nav-detail" tabId="2">
                            <div>
                              <h5 className="mb-3">
                                {productInfo?.title || "-"}
                              </h5>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: productInfo?.description || "",
                                }}
                              />

                              <div>
                                {productInfo?.highlight?.map(
                                  (highlight: string, index: number) => (
                                    <div className="mb-2" key={index}>
                                      <i className="mdi mdi-circle-medium me-1 text-muted align-middle"></i>
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: highlight,
                                        }}
                                      />
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </TabPane>
                        </TabContent>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
export default EcommerceProductDetail;
